import type { FC } from 'react';

import { Trans } from 'react-i18next';

import classNames from 'classnames';

import { CustomWatermark } from 'components/customWatermark';

import { ReactComponent as AiSparklesIcon } from '../../assets/ai-sparkles.svg';
import { PreviewSide } from './previewSide';

interface ISplitScreenPreviewProps {
  removedWatermarkImageUrl: string;
  originalImageUrl: string;
}

export const SplitScreenPreview: FC<ISplitScreenPreviewProps> = ({ removedWatermarkImageUrl, originalImageUrl }) => {
  return (
    <div
      className={classNames(
        'grid grid-cols-[1fr_auto_1fr] gap-x-4 overflow-hidden select-none print:hidden h-full',
        'max-sm:gap-x-2 max-sm:h-auto max-sm:flex max-sm:flex-col max-sm:gap-y-4'
      )}
    >
      <div className='max-mobile:order-2'>
        <PreviewSide
          title={<Trans i18nKey='popups.remove_watermark_popup.original_preview' />}
          imageUrl={originalImageUrl}
          alt='original preview'
        />
      </div>

      <div className='h-full w-px bg-black opacity-20 mt-[42px] max-mobile:h-px max-mobile:mt-0 max-mobile:w-full max-mobile:order-3' />

      <div className='max-mobile:order-1'>
        <PreviewSide
          title={
            <span className='flex items-center gap-x-1 justify-center'>
              <AiSparklesIcon />
              <Trans i18nKey='popups.remove_watermark_popup.watermark_removed_preview' />
            </span>
          }
          imageUrl={removedWatermarkImageUrl}
          alt='watermark removed preview'
        >
          <CustomWatermark />
        </PreviewSide>
      </div>
    </div>
  );
};
